import { getRowIdsApiRequestData } from '../../api/utils/requestData/getRowIdsApiRequestData';
import { Dataset, JSONObject } from '../../types/types';
import { getFilterParamObject } from '../apiRequests/getFilterParamObject';
import { stripEmptyActiveFilters } from '../apiRequests/stripEmptyActiveFilters';
import { getDataKey } from '../getDataKey';

// Build inputs for the locate-by-id ID-only probe. Reads activeFilters/sorting
// directly (not refs) so the caller can pass current state synchronously after
// a filter change.
export const buildLocateRequestData = (
  dataset: Dataset,
  activeFilters: Record<string, unknown> | null,
  activeSorting: any[],
  sessionToken: string | null,
  rowId?: string,
  cachedQueryId?: string | null,
  datasetControl?: JSONObject,
  // Already request-shaped filter merged on top of the converted activeFilters,
  // taking precedence — the probe must scope to the same subset as the grid
  // (e.g. a fullscreen reference's locked default filter).
  additionalFilterObject?: Record<string, any>
) => {
  const idItem = getDataKey(dataset);
  // Mirror fetchDatasetData: drop empty filters (e.g. an unselected filterFirst
  // reference like _dodvid on external-URL entry) so the id-probe never sends
  // `filter[name][matchMode]=`, which the API rejects with 500 and surfaces as
  // a false "record not found".
  const resolvedFilters = stripEmptyActiveFilters(activeFilters || {});
  const resolvedSorting = activeSorting || [];
  const filters = {
    ...getFilterParamObject(resolvedFilters),
    ...(additionalFilterObject ?? {}),
  };
  const requestData = getRowIdsApiRequestData(
    dataset,
    resolvedSorting,
    sessionToken,
    filters,
    null,
    cachedQueryId,
    rowId,
    datasetControl
  );
  return { idItem, resolvedFilters, resolvedSorting, requestData };
};
